module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('a', {
    attrs: {
      "id": "pg_ix"
    }
  }, [_vm._v("Acknowledgments")])]), _c('a', {
    attrs: {
      "id": "pg_ix"
    }
  }), _c('p', {
    staticClass: "FMCO"
  }, [_c('a', {
    attrs: {
      "id": "pg_ix"
    }
  }, [_vm._v("I’d like to thank Stephen Brams for reviewing an early version of the manuscript and pointing out some things I’d missed the first time around. I’d also like to thank my wife, Jacqui, whose constant requests for clarification helped make this a much better work.")]), _c('a', {
    attrs: {
      "id": "pg_x"
    }
  })]), _c('a', {
    attrs: {
      "id": "pg_x"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2129ca1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 75
// module chunks = 0